/**
 * Unified Auth Hook
 * 
 * This hook provides a consistent interface for authentication
 * regardless of whether we're using mock auth or Entra ID.
 */

import { useAuth, AuthContextType } from '@/contexts/AuthContext';
import { useEntraAuth, EntraAuthContextType } from '@/contexts/EntraAuthContext';
import { env } from '@/lib/env';

const AUTH_MODE = env.AUTH_MODE;

export function useAuthContext(): AuthContextType | EntraAuthContextType {
  if (AUTH_MODE === 'entra') {
    return useEntraAuth();
  }
  return useAuth();
}
